// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + {"366":"mobile/share-popup-content","397":"widget/vod-player"}[chunkId] + ".chunk.min.css";
};